<section class="table-content">

  <section class="filters">
    <input (input)="getFees('search', searchFees)" [(ngModel)]="searchFees" type="search"
           name="searchClasses"
           placeholder="Search fee, level, term...">

    <div>
      @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
        <select (change)="getFees('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                id="schoolId">
          <option value="" hidden disabled>Select a school</option>

          @for (s of schools()?.payload; track $index) {
            <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
          }

        </select>
      }

      <select (change)="getFees('academic_year_id', academicYearId)" [(ngModel)]="academicYearId" name="academicYearId"
              id="academicYearId">
        <option value="" hidden disabled>Select an academic year</option>
        <option value="">All academic years</option>

        @for (a of academicYears()?.payload; track $index) {
          <option [value]="a.id">{{ a.name }}</option>
        }
      </select>

      <select (change)="getFees('level_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId" id="schoolId">
        <option value="" hidden disabled>Select a level</option>
        <option value="">All Levels</option>

        @for (s of levels()?.payload; track $index) {
          <option [value]="s.id">{{ s.name }}</option>
        }

      </select>

      <select (change)="getFees('status', feeStatus)" [(ngModel)]="feeStatus" name="status" id="status">
        <option value="" hidden disabled>Select a status</option>
        <option value="">All Statuses</option>

        @for (s of feeStructureStatuses; track $index) {
          <option [value]="s">{{ Helpers.toSentenceCase(s) }}</option>
        }
      </select>
    </div>
  </section>

  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th>FEE NAME</th>
        <th>FEE TYPE</th>
        <th>ACADEMIC YEAR</th>
        <th>AMOUNT(GH₵)</th>
        <th>MANDATORY</th>
        <th>STATUS</th>
        <th class="options-column">ACTIONS</th>
      </tr>
      </thead>

      <tbody>
        @if (isFiltering()) {
          <td colspan="6">
            <app-loading-indicator />
          </td>
        } @else {
          @if (!fees()?.payload?.length) {
            <tr>
              <td colspan="6" class="empty">
                <app-not-found-error>
                  NO FEES FOUND
                </app-not-found-error>
              </td>
            </tr>
          } @else {
            @for (u of fees()?.payload; track $index) {
              <tr>
                <td>
                  {{ u.fee_name }}
                </td>

                <td class="role">
                  <p class="fee-type">{{ u.fee_type }}</p>
                </td>

                <td>
                  {{ u.academic_year_name }}
                </td>

                <td>
                  GH₵{{ u.amount }}
                </td>

                <td class="optional" [class.required]="u.required">
                  <p> {{ u.required ? 'Required' : 'Optional' }}</p>
                </td>

                <td class="status">
                  <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                </td>

                <td class="options-column">
                  <app-action-button>
                    <button (click)="selectFee(u, 'detail')" type="button" class="menu-item">View details</button>

                    <button type="button" class="menu-item" (click)="selectFee(u, 'assign')">Assign fee to student
                    </button>

                    <button type="button" class="menu-item" (click)="selectFee(u, 'edit-fee')">Edit fee</button>

                    <button type="button" class="menu-item" (click)="selectFee(u, 'edit')">Change status</button>
                  </app-action-button>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

  <app-pagination
    [page]="fees()?.pagination?.page ?? 0"
    [size]="fees()?.pagination?.size ?? 10"
    [totalElements]="fees()?.pagination?.totalElements ?? 0"
    [totalPages]="fees()?.pagination?.totalPages ?? 0"
    [first]="fees()?.pagination?.first ?? true"
    [last]="fees()?.pagination?.last ?? false"
    [hasNext]="fees()?.pagination?.hasNext ?? false"
    [hasPrevious]="fees()?.pagination?.hasPrevious ?? false"
    (pageChange)="loadPage($event)">
  </app-pagination>

</section>

@if (setChangeStatusPopup()) {
  <section class="pop-up">
    <div class="bg" (click)="setChangeStatusPopup.set(false)"></div>

    <form #changeFeeStatusForm="ngForm" (ngSubmit)="changeFeeStatus(changeFeeStatusForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               viewBox="0 0 32 32" xml:space="preserve" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
              fill: none;
              stroke: #fff;
              stroke-width: 2;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-miterlimit: 10;
            } </style>
              <path
                d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2 c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"></path>
              <g> <path
                d="M16,11c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,12.7,17.9,11,16,11z"></path>
                <path
                  d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V6C32,5.4,31.6,5,31,5z"></path> </g> </g></svg>
        </div>

        <div>
          <h6>Add a Fee Type</h6>
          <small>Add a new fee</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <h6>Current Status:</h6>
          <div class="status">
            <p [ngClass]="selectedFee?.status">{{ Helpers.replaceUnderscore(selectedFee?.status ?? '') }}</p>
          </div>
        </div>

        <div>

          <label for="fee-status">Change Status <span class="required-check">*</span></label>

          <select required [(ngModel)]="newStatus" type="text" name="status" id="fee-status">
            <option value="" hidden disabled>Select a status</option>

            @for (fee of feeStructureStatuses; track $index) {

              @if (selectedFee?.status !== fee) {
                <option [value]="fee">{{ Helpers.toSentenceCase(fee) }}</option>
              }
            }

          </select>
        </div>

        @if (newStatus === 'ACTIVE') {
          <div class="checkbox">
            <input [(ngModel)]="feeRequired" type="checkbox" name="feeRequired" id="feeRequired">
            <label for="feeRequired">Required for all students</label>
          </div>
        }

        <button class="secondary-button">Change Status</button>

      </div>

    </form>
  </section>
}

@if (setAssignFee()) {
  <section class="pop-up">
    <div class="bg" (click)="setAssignFee.set(false)"></div>

    <form #assignFeeForm="ngForm" (ngSubmit)="assignFee(assignFeeForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               viewBox="0 0 32 32" xml:space="preserve" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
              fill: none;
              stroke: #fff;
              stroke-width: 2;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-miterlimit: 10;
            } </style>
              <path
                d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2 c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"></path>
              <g> <path
                d="M16,11c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,12.7,17.9,11,16,11z"></path>
                <path
                  d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V6C32,5.4,31.6,5,31,5z"></path> </g> </g></svg>
        </div>

        <div>
          <h6>Assign Fee</h6>
          <small>Assign fee to a student</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="query">Search Student</label>
          <input (input)="getStudents(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search for a student...">

          @if (students()?.payload?.length && query !== '') {
            <ul>

              @for (s of students()?.payload; track s.id) {
                <li (click)="selectStudent(s)">
                  <h6>{{ s.first_name }} {{ s.last_name }}</h6>
                  <p>School ID: {{ s.public_id }}</p>
                </li>
              }

            </ul>
          }
        </div>

        @if (selectedStudent) {
          <div class="school-card">
            <div class="heading">
              <svg height="24px" width="24px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#fff"
                   stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
                  fill: #fff;
                } </style>
                  <g> <path class="st0"
                            d="M366.042,378.266c-26.458-9.72-49.309-18.113-51.793-42.026c-1.149-11.024-0.214-23.982,2.702-37.507 c9.144-9.798,16.72-23.936,24.484-45.691c15.458-5.955,25.31-19.192,30.109-40.442c2.461-10.885-1.058-22.073-9.655-30.807 c0.773-13.206,0.095-13.928-0.402-14.456l-0.542-0.536H151.497v14.914c-9.897,9.115-13.61,19.503-11.038,30.885 c4.794,21.242,14.648,34.48,30.12,40.442c7.762,21.754,15.332,35.885,24.464,45.675c2.06,9.518,4.158,23.61,2.71,37.523 c-2.484,23.913-25.336,32.306-51.795,42.026c-36.32,13.338-77.484,28.462-77.484,88.641C68.474,485.634,126.653,512,256,512 c129.347,0,187.526-26.366,187.526-45.093C443.526,406.729,402.362,391.605,366.042,378.266z M233.908,484.578L203.021,359.12 l37.47,15.598l-2.302,20.66l6.572-0.148L233.908,484.578z M277.101,395.378l-2.302-20.66l37.47-15.598l-30.887,125.458 l-10.854-89.348L277.101,395.378z"></path>
                    <path class="st0"
                          d="M91.083,82.779l54.864,24.13v36.397h222.66v-36.397l22.395-9.852v51.234c-4.75,0.753-8.389,4.728-8.389,9.495 c0,4.146,2.741,7.74,6.704,9.053l-6.378,40.217c-0.421,2.663,0.34,5.357,2.081,7.392c1.739,2.042,4.28,3.214,6.972,3.214h16.792 c2.692,0,5.233-1.172,6.968-3.214c1.745-2.034,2.506-4.728,2.085-7.392l-6.374-40.217c3.969-1.312,6.714-4.907,6.714-9.053 c0-4.767-3.643-8.742-8.397-9.495V88.804l13.686-6.017c2.696-1.172,4.439-3.789,4.439-6.654c0-2.85-1.739-5.458-4.433-6.646 L272.931,3.284C267.987,1.102,262.72,0,257.273,0c-5.446,0-10.712,1.102-15.652,3.284L91.081,69.487 c-2.692,1.188-4.431,3.796-4.431,6.646C86.649,79.006,88.392,81.614,91.083,82.779z"></path> </g> </g></svg>
              <h4>Selected Student</h4>
            </div>

            <div class="school-content">
              <p>STUDENT NAME</p>
              <p>STUDENT ID</p>

              <h5>{{ selectedStudent.first_name }} {{ selectedStudent.last_name }}</h5>
              <h5>{{ selectedStudent.public_id }}</h5>
            </div>
          </div>
        }

        <div>
          <label for="discountAmount">Discount (%)</label>
          <input [max]="selectedFee?.amount ?? null" placeholder="5%" [(ngModel)]="discountAmount" type="number"
                 name="discountAmount" id="discountAmount">
        </div>

        <div>
          <label for="adjustmentAmount">Adjustment Amount (GH₵)</label>
          <small class="negative-amount">*Can accept a negative amount</small>
          <input max="100" placeholder="0.00" [(ngModel)]="adjustmentAmount" type="number" name="adjustmentAmount"
                 id="adjustmentAmount">
        </div>

        @if (adjustmentAmount && adjustmentAmount > 0) {
          <div>
            <label for="adjustmentReason">Adjustment Reason</label>
            <textarea required placeholder="Provide a reason for this adjustment..." cols="30" rows="3"
                      [(ngModel)]="adjustmentReason" type="text" name="adjustmentReason"
                      id="adjustmentReason"></textarea>
          </div>
        }

        <button [disabled]="assignFeeForm.invalid" class="secondary-button" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Confirm
          }
        </button>


      </div>

    </form>
  </section>
}

<section [class.show]="setFeeDetail()" class="slider">
  <div class="bg" (click)="setFeeDetail.set(false)"></div>

  <div class="slider-content">
    <div class="slider-heading">
      <div>
        <h5>{{ selectedFee?.fee_name ?? '' }}</h5>
        <!--        <small>{{ selectedFee?.public_id }}</small>-->
      </div>

      <div class="status">
        <p [ngClass]="selectedFee?.status ?? ''">{{ Helpers.replaceUnderscore(selectedFee?.status ?? '') }}</p>
      </div>
    </div>

    <div class="amount-paid">
      <h6>AMOUNT</h6>
      <h2>GH₵{{ selectedFee?.amount ?? '' }}</h2>
    </div>

    <div class="fee-summary">
      <h6>FEE DETAILS</h6>

      <div class="fee-summary-container">
        <div class="record">
          <small>Fee Name</small>
          <p>{{ selectedFee?.fee_name ?? 'N/A' }}</p>
        </div>

        <div class="record">
          <small>Fee Type</small>
          <p>{{ selectedFee?.fee_type ?? 'N/A' }}</p>
        </div>

        <div class="record">
          <small>Academic Year</small>
          <p>{{ selectedFee?.academic_year_name ?? 'N/A' }}</p>
        </div>

        <div class="record">
          <small>Academic Term</small>
          <p>{{ selectedFee?.term_name ?? 'N/A' }}</p>
        </div>

        <div class="record">
          <small>Mandatory</small>
          <p>{{ selectedFee?.required ? 'Yes' : 'No' }}</p>
        </div>

      </div>

    </div>

    @if (feeSummary() !== null && feeSummary()?.payload) {
      <div class="billing-summary">
        <h6>BILLING SUMMARY</h6>

        <div class="bill-container">
          <div class="students">
            <h5>{{ feeSummary()?.payload?.total_student_fees ?? 0 }}</h5>
            <small>Students Billed</small>
          </div>

          <div class="billed">
            <h5>GH₵{{ Helpers.formatAmount(feeSummary()?.payload?.total_billed_amount) }}</h5>
            <small>Total Billed</small>
          </div>

          <div class="paid">
            <h5>GH₵{{ Helpers.formatAmount(feeSummary()?.payload?.total_paid_amount) }}</h5>
            <small>Total Paid</small>
          </div>

          <div class="outstanding">
            <h5>GH₵{{ Helpers.formatAmount(feeSummary()?.payload?.total_outstanding_amount) }}</h5>
            <small>Outstanding</small>
          </div>
        </div>

      </div>

      <div class="collection-rate">
        <div class="collection-data">
          <small>Collection Rate</small>
          <small class="collection-percent">{{ feeSummary()?.payload?.percentage_paid ?? 0 }}%</small>
        </div>

        <div class="payment-range">
          <div [style.width.%]="feeSummary()?.payload?.percentage_paid ?? 0"></div>
        </div>

        <div class="collection-stats">
          <div class="paid">
            <p>{{ feeSummary()?.payload?.total_paid ?? 0 }}</p>
            <small>Paid</small>
          </div>

          <div class="students">
            <p>{{ feeSummary()?.payload?.total_partially_paid ?? 0 }}</p>
            <small>Partial</small>
          </div>

          <div class="billed">
            <p>{{ feeSummary()?.payload?.total_unpaid ?? 0 }}</p>
            <small>Unpaid</small>
          </div>

          <div class="outstanding">
            <p>{{ feeSummary()?.payload?.total_overdue ?? 0 }}</p>
            <small>Overdue</small>
          </div>
        </div>
      </div>
    }

  </div>
</section>


@if (setEditFee()) {
  <section class="pop-up">
    <div class="bg" (click)="setEditFee.set(false)"></div>

    <form #editFeeForm="ngForm" (ngSubmit)="updateFee(editFeeForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               viewBox="0 0 32 32" xml:space="preserve" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
              fill: none;
              stroke: #fff;
              stroke-width: 2;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-miterlimit: 10;
            } </style>
              <path
                d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2 c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"></path>
              <g> <path
                d="M16,11c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,12.7,17.9,11,16,11z"></path>
                <path
                  d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V6C32,5.4,31.6,5,31,5z"></path> </g> </g></svg>
        </div>

        <div>
          <h6>Edit Fee</h6>
          <small>Update fee details</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="editFeeName">Name of Fee <span class="required-check">*</span></label>
          <input required [(ngModel)]="editFeeName" type="text" name="editFeeName" id="editFeeName"
                 placeholder="e.g. Tuition Fee">
        </div>

        <div class="levels-field">
          <label>Select Levels <span class="required-check">*</span></label>

          <div class="levels-grid">
            <div class="level-option select-all" [class.selected]="areAllEditLevelsSelected"
                 (click)="selectAllEditLevels()">
              <div class="level-checkbox">
                @if (areAllEditLevelsSelected) {
                  <span>✓</span>
                }
              </div>

              <span class="level-name">Select All</span>
            </div>

            @for (level of levels()?.payload; track level.id) {
              <div class="level-option" [class.selected]="editSelectedLevels.includes(level.id)"
                   (click)="selectEditLevel(level.id)">
                <div class="level-checkbox">
                  @if (editSelectedLevels.includes(level.id)) {
                    <span>✓</span>
                  }
                </div>

                <span class="level-name">
          {{ level.name }}
        </span>
              </div>
            }
          </div>
        </div>

        <button [disabled]="editFeeForm.invalid || !editSelectedLevels.length" class="secondary-button" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Save Changes
          }
        </button>

      </div>

    </form>
  </section>
}

